/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Определяет тип содержимого документа.
 * @export
 * @enum {string}
 */
export enum FxIdDomainEntitiesDocumentsContentType {
    Unspecified = 0,
    Markdown = 1,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainEntitiesDocumentsContentType(value: any): boolean {
    for (const key in FxIdDomainEntitiesDocumentsContentType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesDocumentsContentType, key)) {
            if (FxIdDomainEntitiesDocumentsContentType[key as keyof typeof FxIdDomainEntitiesDocumentsContentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainEntitiesDocumentsContentTypeFromJSON(json: any): FxIdDomainEntitiesDocumentsContentType {
    return FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsContentType {
    return json as FxIdDomainEntitiesDocumentsContentType;
}

export function FxIdDomainEntitiesDocumentsContentTypeToJSON(value?: FxIdDomainEntitiesDocumentsContentType | null): any {
    return value as any;
}

export function FxIdDomainEntitiesDocumentsContentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsContentType {
    return value as FxIdDomainEntitiesDocumentsContentType;
}

